import {Button, Input, Textarea, Typography,} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {getDegrees} from "../../../services/degree/degree"
import {getStageDegrees} from "../../../services/stage_degree/stage_degree"
import {getFieldBranches} from "../../../services/branch/branch";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import Validator from "../../../helper/validator/Validator";
import {Toaster} from "../../../helper/Toaster";
import {updateBackOfficeAgentRequestExpertInfo} from "../../../services/back_office/agent";
import {checkAll} from "../../../helper/validator/Check";

export function BackOfficeAgentRequestExpertInfo({
                                                   activeStep,
                                                   setActiveStep,
                                                   agentRequest,
                                                   setAgentRequest,
                                                   handleNext,
                                                   handlePrev,
                                                   isFirstStep,
                                                   isLastStep,
                                                   allowedStep,
                                                   setAllowedStep,
                                                   person_id
                                                 }) {

  const [id, setId] = useState(null);
  const [degreeId, setDegreeId] = useState("")
  const [stageDegreeId, setStageDegreeId] = useState("")
  const [experience, setExperience] = useState(null)
  const [speciality, setSpeciality] = useState("")
  const [aboutMe, setAboutMe] = useState("")

  const [branchIds, setBranchIds] = useState([]);

  const [personId, setPersonId] = useState(null);

  useEffect(() => {
    setPersonId(person_id);
  }, [person_id]);

  useEffect(() => {
    if (!agentRequest || !agentRequest.id) {
      return
    }
    setAgentRequest(agentRequest);
    setId(agentRequest.id);
    const bids = (agentRequest && agentRequest.branch_ids)
      ? [...new Set(agentRequest.branch_ids.split(',').map(Number))]
      : [];
    setBranchIds(bids);
    setDegreeId((agentRequest && agentRequest.degree_id) || "");
    setStageDegreeId((agentRequest && agentRequest.stage_degree_id) || "");
    setExperience((agentRequest && agentRequest.experience) || null);
    setSpeciality((agentRequest && agentRequest.speciality) || "");
    setAboutMe((agentRequest && agentRequest.about_me) || "");


  }, [agentRequest])

  const save = async () => {
    const branches = branchIds.map(bid => ({
      agent_id: id,
      branch_id: bid,
    }));

    const data = {
      agent_request: {
        id: id,
        degree_id: parseInt(degreeId),
        stage_degree_id: parseInt(stageDegreeId),
        experience: parseInt(experience),
        // field_id: parseInt(field_id),
        // branch_id: parseInt(branch_id),
        speciality: speciality,
        about_me: aboutMe,
        person_id: person_id,
      },
      request_branch_list: branches
    };
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>);
      return
    }
    let result;

    result = await updateBackOfficeAgentRequestExpertInfo(data);

    if (result.status === 200) {
      const {UserAgentRequest} = result.data;
      setAgentRequest(UserAgentRequest);
      if (allowedStep === 2) {
        setAllowedStep(3)
      }
      handleNext(3);
    }
  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">

          <div className="flex flex-col w-full mb-4">
            <SelectInput
              label={Dict("degree")}
              defaultValue={degreeId}
              autoLoadService={getDegrees}
              onChange={setDegreeId}
            />
            <Validator state={degreeId} rules="required"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <SelectInput
              label={Dict("stage_degree")}
              defaultValue={stageDegreeId}
              autoLoadService={getStageDegrees}
              onChange={setStageDegreeId}
            />
            <Validator state={stageDegreeId} rules="required"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={experience}
                   label={Dict('experience')}
                   placeholder={Dict('experience')}
                   onChange={(e) => {
                     setExperience(e.target.value)
                   }}
            />
            <Validator state={experience} rules="num"/>
            <Validator state={experience} rules="required"/>
          </div>

          <div className="flex flex-col w-full mb-4">
            <Input className="flex flex-row"
                   variant="standard"
                   value={speciality}
                   label={Dict('speciality')}
                   placeholder={Dict('speciality')}
                   onChange={(e) => {
                     setSpeciality(e.target.value)
                   }}
            />
            <Validator state={speciality} rules="required"/>
            <Validator state={speciality} rules="alphanumeric"/>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6">

          <SelectInput
            label={Dict("branch")}
            defaultValue={branchIds}
            multiselect={true}
            autoLoadService={getFieldBranches}
            autoLoadRender={({field_title, title}) => {
              return field_title + " - " + title
            }}
            onChange={setBranchIds}
          />
          <Validator state={branchIds} rules="required"/>


          <div className="flex flex-col w-full mb-4">
            <Textarea variant="standard"
                      value={aboutMe}
                      label={Dict('about_me')}
                      onChange={(e) => {
                        setAboutMe(e.target.value)
                      }}
            />
            <div className="flex flex-row">
              <Validator state={aboutMe} rules="required"/>
            </div>
          </div>
        </div>


        <div className="mt-32 flex justify-between">
          <Button onClick={save} disabled={isLastStep}>
            مرحله بعدی
          </Button>
          <Button onClick={() => {
            handlePrev(1)
          }} disabled={isFirstStep}>
            مرحله قبلی
          </Button>
        </div>
      </>
    </ValidatorProvider>
  )
    ;
}